import { render, staticRenderFns } from "./tripAlert.vue?vue&type=template&id=386a1692&scoped=true"
import script from "./tripAlert.vue?vue&type=script&lang=js"
export * from "./tripAlert.vue?vue&type=script&lang=js"
import style0 from "./tripAlert.vue?vue&type=style&index=0&id=386a1692&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "386a1692",
  null
  
)

export default component.exports